export default {
  namespaced: true,

  state: {
    items: [],
  },

  mutations: {
    add (state, data) {
      state.items.push(data)
    },

    clear (state) {
      state.items = []
    },

    remove (state, id) {
      const index = state.items
        .findIndex(item => item.data.id === id)

      if (index !== -1) {
        state.items.splice(index, 1)
      }
    },
  },
}
